// Mock data generator for winner information
// Used until backend provides actual winner details

const AVATAR_PLACEHOLDERS = [
  'https://i.pravatar.cc/150?img=1',
  'https://i.pravatar.cc/150?img=2',
  'https://i.pravatar.cc/150?img=3',
  'https://i.pravatar.cc/150?img=4',
  'https://i.pravatar.cc/150?img=5',
  'https://i.pravatar.cc/150?img=6',
  'https://i.pravatar.cc/150?img=7',
  'https://i.pravatar.cc/150?img=8',
];

const PRODUCT_CATEGORIES = [
  'Mobilní telefon',
  'Zážitek',
  'Dovolená',
  'Nábytek',
  'Elektronika',
  'Domácí spotřebiče',
  'Sport a volný čas',
  'Auto',
  'Módní doplněk',
  'Hodinky',
];

/**
 * Generate a random avatar URL for a winner
 * @param seed - Optional seed for consistent avatar selection
 */
export const generateWinnerAvatar = (seed?: number): string => {
  const index = seed
    ? seed % AVATAR_PLACEHOLDERS.length
    : Math.floor(Math.random() * AVATAR_PLACEHOLDERS.length);
  return AVATAR_PLACEHOLDERS[index];
};

/**
 * Calculate savings percentage
 * @param soldPrice - Final auction price
 * @param estimatedRetailPrice - Original/retail price (if available)
 */
export const calculateSavings = (
  soldPrice: number | undefined,
  estimatedRetailPrice?: number
): string => {
  // If no price provided or invalid, generate a realistic savings (15-40%)
  if (!soldPrice || isNaN(soldPrice)) {
    const savingsPercent = Math.floor(Math.random() * 25) + 15; // 15-40%
    return `Ušetříš -${savingsPercent}% z běžné ceny`;
  }

  // If no retail price provided, generate a realistic savings (15-40%)
  if (!estimatedRetailPrice) {
    const savingsPercent = Math.floor(Math.random() * 25) + 15; // 15-40%
    return `Ušetříš -${savingsPercent}% z běžné ceny`;
  }

  const savingsPercent = Math.round(
    ((estimatedRetailPrice - soldPrice) / estimatedRetailPrice) * 100
  );
  return `Ušetříš -${savingsPercent}% z běžné ceny`;
};

/**
 * Determine product category from title
 * @param title - Auction title
 */
export const determineCategory = (title: string): string => {
  const lowerTitle = title.toLowerCase();

  if (lowerTitle.includes('iphone') || lowerTitle.includes('samsung') || lowerTitle.includes('telefon')) {
    return 'Mobilní telefon';
  }
  if (lowerTitle.includes('dovolená') || lowerTitle.includes('pobyt') || lowerTitle.includes('hotel')) {
    return 'Dovolená';
  }
  if (lowerTitle.includes('zážitek') || lowerTitle.includes('wellness') || lowerTitle.includes('spa')) {
    return 'Zážitek';
  }
  if (lowerTitle.includes('dji') || lowerTitle.includes('dron') || lowerTitle.includes('drone')) {
    return 'Dron';
  }
  if (lowerTitle.includes('auto') || lowerTitle.includes('car') || lowerTitle.includes('vozidlo')) {
    return 'Auto';
  }
  if (lowerTitle.includes('káv') || lowerTitle.includes('coffee') || lowerTitle.includes('espresso')) {
    return 'Domácí spotřebiče';
  }
  if (lowerTitle.includes('hodinky') || lowerTitle.includes('watch')) {
    return 'Hodinky';
  }
  if (lowerTitle.includes('boty') || lowerTitle.includes('shoes') || lowerTitle.includes('tričko')) {
    return 'Módní doplněk';
  }
  if (lowerTitle.includes('notebook') || lowerTitle.includes('laptop') || lowerTitle.includes('tablet')) {
    return 'Elektronika';
  }

  // Default to random category
  return PRODUCT_CATEGORIES[Math.floor(Math.random() * PRODUCT_CATEGORIES.length)];
};

/**
 * Format price to Czech format
 * @param price - Price number
 */
export const formatPrice = (price: number | undefined): string => {
  if (price === undefined || price === null || isNaN(price)) {
    return '0 Kč';
  }
  return `${price.toLocaleString('de-DE')} Kč`;
};
